import React from 'react'
import marketStyle from './TheMarket.module.css'
import { Box, Button, Typography } from '@mui/material'
import { Link } from 'react-router-dom'
import IconButton from '@mui/material/IconButton';
import EditNoteOutlinedIcon from '@mui/icons-material/EditNoteOutlined';
import BorderColorOutlinedIcon from '@mui/icons-material/BorderColorOutlined';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import { useState } from 'react';
import axios from 'axios';
import { useEffect } from 'react';

// import this for redux read write
import { useSelector, useDispatch } from 'react-redux'
import { setNotifications } from '../../state/GlobalState'
import { setNotificationCount } from '../../state/GlobalState'

import { useParams } from 'react-router-dom';
import DeleteConformation from '../DeleteConformation/DeleteConformation';
import useBackdrop from '../../hooks/useBackdrop/useBackdrop';
import useToast from '../../hooks/useToast';

const TheMarket = () => {
    const { invId, channelId } = useParams();
    // get data from redux
    const name = useSelector((state) => state.globalData.name);
    const count = useSelector((state) => state.globalData.notificationCount);
    const [tempData, setTempData] = useState(null);
    const { Toast, showToast } = useToast();
    const { openBackdrop, closeBackdrop, BackdropComponent } = useBackdrop();


    const dispatch = useDispatch()

    const [data, setData] = useState([])

    const getAllMarketData = async () => {
        try {
            const res = await axios.get(
                `${process.env.REACT_APP_COSMOSINV}/channel/getChannelById/${channelId}`
            )
            setData(res.data)
            console.log(res.data)
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        getAllMarketData()
    }, [])

    const deleteMarketData = async () => {
        try {
            const res = await axios.delete(
                `${process.env.REACT_APP_COSMOSINV}/graph/deleteGraph/${invId}/${channelId}/${tempData.graphId}`
                ).then((res) => {
                    showToast("success", "Market  Delete Successfully");
                    handleDeleteModal();
                    getAllMarketData();
                })
                

            dispatch(setNotificationCount({
                count: count + 1,
            }))

        } catch (error) {
            console.log(error)
        }
    }




    const [deleteModal, setDeleteModal] = useState(false);

    const handleDeleteModal = (data) => {
        setDeleteModal(prev => !prev)
        if (data !== undefined && data !== "" && data !== null) {
            setTempData(data)
        }
    }


    return (
        <>
 <Toast />
            <BackdropComponent />
            <div className={marketStyle.companyDetailsMain}>
                <div className={marketStyle.companyDetailsContent}>
                    <div className={marketStyle.companyDetailsHeader}>
                        <Typography sx={{ marginTop: '1%', color: '#121926', fontWeight: '600', fontSize: '20px' }} >
                            The Market
                        </Typography>
                        {/* <Link to='/addmarket'> */}
                        <Link to={`create`}>
                            <Button sx={{ textTransform: 'capitalize' }} variant='contained'>Add</Button>
                        </Link>
                    </div>
                    <Box className={marketStyle.companyDetailsComponent}>
                        <div className={marketStyle.companyDetailsComponentLeft}>
                            <Typography variant='h5' sx={{ fontSize: '15px', fontWeight: '600' }}>
                                Name
                            </Typography>
                        </div>
                        <div className={marketStyle.companyDetailsComponentRight}>
                            <Typography variant='h6' sx={{ fontSize: '15px', fontWeight: '600' }}>
                                Last modified
                            </Typography>
                            <Typography variant='h6' sx={{ fontSize: '15px', fontWeight: '600' }}>
                                Action
                            </Typography>
                        </div>
                    </Box>
                    {data.graphs?.map((gp) =>
                        <Box className={marketStyle.companyDetailsComponent}>
                            <div className={marketStyle.companyDetailsComponentLeft}>
                                <Typography variant='h5' sx={{ fontSize: '15px', fontWeight: '600' }}>
                                    {gp.graphName}
                                </Typography>
                            </div>
                            <div className={marketStyle.companyDetailsComponentRight}>
                                <Typography variant='h6' sx={{ fontSize: '15px' }}>
                                    {gp.date}
                                </Typography>
                                <Typography variant='h6' sx={{ fontSize: '15px', fontWeight: '600', display: 'flex', alignItems: 'baseline' }}>
                                    <Link to={`${gp?.graphId}`} state={{ graphInfo: gp }} >
                                        {/* <Link to= '/EditInvOppo'> */}
                                        <BorderColorOutlinedIcon sx={{ color: '#16469d', cursor: 'pointer' }} />
                                    </Link>
                                    <IconButton disableRipple onClick={() => handleDeleteModal(gp)}>
                                        <DeleteForeverOutlinedIcon sx={{ color: '#16469d', cursor: 'pointer', marginLeft: '10px' }} />
                                    </IconButton>
                                </Typography>
                            </div>
                        </Box>
                    ).reverse()}
                </div>
            </div>

            <DeleteConformation
                onClose={handleDeleteModal}
                open={deleteModal}
                onConfirm={() => deleteMarketData()}
                onReject={() => { }}
            >
                <h2>Delete Market</h2>
                <p>Are you sure you want to Delete this Market?</p>

            </DeleteConformation>
        </>
    )
}

export default TheMarket





